import React from "react";
import { ENGAGE_STAGES } from "./ecosystemData";

const Engagement = () => {
    return (
        <section className="w-full container mx-auto px-6 md:px-12 lg:px-20 pt-16 lg:pt-28 pb-24 lg:pb-36">
            <div className="mb-10 lg:mb-12 text-center">
                <h2 className="text-3xl md:text-4xl font-normal tracking-tight text-blue10 leading-tight">
                    How an engagement <span className="font-light italic text-primaryBrand">starts</span>
                </h2>
            </div>

            <div className="relative bg-white rounded-2xl border border-solid border-FGNeutralAccent shadow-sm p-7 md:p-10">
                <style>{`
                    /* a bright Tron-style pulse runs the length of the rail, then resets */
                    @keyframes engRun { 0% { transform: translateX(-120%); } 100% { transform: translateX(340%); } }
                    .eng-runner { animation: engRun 4.2s linear infinite; }
                    @media (prefers-reduced-motion: reduce) { .eng-runner { animation: none; opacity: 0; } }
                `}</style>

                {/* connector line (desktop only) — sits behind the disc row.
                    overflow-hidden keeps the running light inside the rail bounds */}
                <div
                    className="hidden lg:block absolute h-[2px] z-0 rounded-full overflow-hidden"
                    style={{
                        left: "12.5%",
                        width: "75%",
                        top: "calc(40px + 24px)",
                        background: "linear-gradient(90deg, #A5C3EB 0%, #A8AEDA 50%, #182553 100%)",
                    }}
                >
                    <div
                        className="eng-runner absolute inset-y-0 left-0"
                        style={{
                            width: "32%",
                            background: "linear-gradient(90deg, rgba(124,176,255,0) 0%, rgba(150,194,255,0.95) 50%, rgba(124,176,255,0) 100%)",
                        }}
                    />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6 relative z-10">
                    {ENGAGE_STAGES.map((s, i) => {
                        const isLast = i === ENGAGE_STAGES.length - 1;
                        return (
                            <div key={s.n} className="flex flex-col items-center text-center">
                                <div
                                    className="w-12 h-12 rounded-full grid place-items-center mb-4 border border-solid"
                                    style={
                                        isLast
                                            ? { background: "radial-gradient(circle at 50% 30%, #243069 0%, #182553 50%, #0A0F1F 100%)", border: "none", boxShadow: "inset 0 1px 0 rgba(255,255,255,0.18), 0 4px 10px rgba(15,20,36,0.18)" }
                                            : { background: "#fff", borderColor: "#E5E7EC", boxShadow: "0 1px 2px rgba(15,20,36,0.06), 0 4px 10px rgba(15,20,36,0.06)" }
                                    }
                                >
                                    <span className="font-semibold text-[15px] tracking-tight" style={{ color: isLast ? "#fff" : "#182553" }}>{s.n}</span>
                                </div>
                                <h3 className="text-base md:text-[17px] font-medium tracking-tight text-blue10 leading-snug">{s.t}</h3>
                                <p className="text-[13px] leading-relaxed text-grey45 mt-2 max-w-[220px]">{s.d}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Engagement;
